import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import Modal from "react-bootstrap/Modal";
import AddIcon from "@material-ui/icons/Add";
import { useDispatch } from "react-redux";
import { addList } from "../../../redux/reducers/Ubicaciones/disposicionesSlice";
import FormDisposicion from "./FormDisposicion";
import createDisposicion from "../../services/Disposiciones/createDisposicion";

const useStyles = makeStyles((theme) => ({
  button: {
    textAlign: "center",
    left: "90%",
    background: "silver",
  },
  buttonSubmit: {
    textAlign: "center",
    left: "40%",
    background: "silver",
    top: 15,
  },

  valor: {
    cursor: "pointer",
    marginTop: theme.spacing(2),
    margin: theme.spacing(2),
  },

  formControl: {
    margin: theme.spacing(-2),
    minWidth: 250,
    Width: 300,
  },
  selectEmpty: {
    marginTop: theme.spacing(1),
  },

  root: {
    "& > *": {
      margin: theme.spacing(3),

      left: "-5%",
      background: "silver",
      top: 15,
    },
  },
}));

const ModalCrearDisposicion = () => {
  const styles = useStyles();
  const [show, setShow] = useState(false);
  const [nombre1, setNombre1] = useState(false);
  const handleClose = () => {
    setShow(!show);
    setNombre1(false);
  };
  const dispatch = useDispatch();

  const handleClick = (data) => {
    setNombre1(true);
    createDisposicion(data).then(() => {
      setShow(false);
      dispatch(addList([]));
    });
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddIcon />}
        className={styles.valor}
        onClick={() => handleClose()}
      >
        Nueva disposición
      </Button>

      <div className={styles.root}>
        <Modal show={show} onHide={handleClose} backdrop="static" centered>
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Nueva disposición
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormDisposicion onSubmit={handleClick} nombre1={nombre1}>
              {" "}
            </FormDisposicion>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default ModalCrearDisposicion;
